import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Organization } from 'src/app/models/organization';
import { User } from 'src/app/models/user';
import { OrganizationsService } from 'src/app/services/organizations.service';
import { UsersService } from 'src/app/services/users.service';
import { InstanceService } from 'src/app/services/centrex/instance.service';
import { Instance } from 'src/app/models/centrex/instance';
import { TranslateModule } from '@ngx-translate/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatNavList, MatListItem, MatListItemIcon, MatListItemTitle } from '@angular/material/list';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css'],
    imports: [MatNavList, MatListItem, RouterLink, RouterLinkActive, MatIcon, MatListItemIcon, MatListItemTitle, MatDivider, TranslateModule]
})
export class NavMenuComponent implements OnInit, OnDestroy {
    @Input() isExpanded: boolean = true;
    isShowing = false;
    showSubmenu: boolean = false;

    constructor(private usersService: UsersService, protected organizationsService: OrganizationsService, protected instanceService: InstanceService) {}

    ngOnInit() {}

    ngOnDestroy() {}

    mouseenter() {
        if (!this.isExpanded) {
            this.isShowing = true;
        }
    }

    mouseleave() {
        if (!this.isExpanded) {
            this.isShowing = false;
        }
    }
}
